import { useEffect, useRef } from "react";
import { useIsPresent } from "motion/react";

/**
 * Returns the live value, or its previous value while the component is
 * exiting under AnimatePresence. The context keeps updating inside exiting
 * panes, so state like canGoBack would flip mid exit animation without this
 */
export const useFrozenWhileExiting = <T>(value: T): T => {
  const isPresent = useIsPresent();
  const lastPresentValue = useRef(value);

  useEffect(() => {
    if (isPresent) {
      lastPresentValue.current = value;
    }
  });

  return isPresent ? value : lastPresentValue.current;
};
